<template>
<div>
    <v-textarea v-model="computed_model" auto-grow :filled="edit" @input="emitInput()" rows="1" class="regular py-1 text-xs-center language" />
</div>
</template>

<script>
export default {
    data() {
        return {
            edit: false,
            model: this.identifier
        }
    },
    props: {
        identifier: {
            type: String,
            default: ""
        }
    },
    computed: {
        computed_model: {
            get: function () {
                return this.model;
            },
            set: function (newvalue) {
                this.model = newvalue
            }
        }
    },
    watch: {
        identifier: {
            handler(newValue) {
                this.model = newValue;
            }
        }
    },
    methods: {
        clean() {
            this.edit = false;
        },

        emitInput() {
            this.edit = true;
            this.$emit('input', this.computed_model);
            this.$emit('update:identifier', this.computed_model);
        },
    },
}
</script>

<style>
.language.v-input .v-input__control .v-input__slot .v-text-field__slot textarea {
    margin: 0 !important;
    padding-right: 0px !important;
}

.language.v-input .v-input__control .v-input__slot {
    min-height: 30px !important;
}

.language.v-input .v-input__control .v-text-field__details {
    display: none;
}

.language.v-input .v-input__control {
    min-height: 33px !important;
}

.language.v-text-field {
    margin-top: 0px !important;
}
</style>
